import SchemaPage from '@/docs-partials/endpoints';
import * as React from 'react';
export default {
  SchemaPage,
  React
};